import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { UserHelperService } from "~/app/shared/userHelper.service";

@Injectable({
  providedIn: "root",
})
export class EmotionTransferGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (UserHelperService.getEmotionTransferFromLocalStorage()) {
      return true;
    }
    return this.router.parseUrl("/projects/not-found");
  }
}
